/// <reference types="@angular/localize" />

import { bootstrapApplication } from "@angular/platform-browser";
import { ServerSidePublicConfigDataResponse } from "backend/model/serverSidePublicConfigDataResponse";
import { AppComponent } from "src/standard/pages/app.component";
import { appConfig } from "src/standard/pages/app.config";

import "@total-typescript/ts-reset";

declare global {
  var __settings: ServerSidePublicConfigDataResponse | undefined;

  var __locale: string;
  var __dateLocale: string | undefined;
  var __numberLocale: string | undefined;
  var __rtl: boolean;

  // Maps a specific event name to an event type
  interface GlobalEventHandlersEventMap {
    "keydown.enter": KeyboardEvent;
    "keydown.space": KeyboardEvent;
  }
}

void bootstrapApplication(AppComponent, appConfig);
